import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "text-success fw-bold" }
const _hoisted_3 = { class: "col-12 mutted small p-0" }
const _hoisted_4 = { class: "p-2" }
const _hoisted_5 = { class: "text-success fw-bold" }

import PersonalTable from '@/components/PersonalTable.vue'
    import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElMessage, ElMessageBox } from 'element-plus';
    // import { useStore } from 'vuex';
    import { User } from '@/services/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ReportsView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const getting = ref<boolean>(false)
    const reports = ref<Array<any>>([])
    const from = new Date()
    from.setDate((new Date()).getDate() - 7)
    const range = ref<Array<Date>>([
        from, new Date()
    ])
    const total = ref<number|undefined>(undefined)
    const sellers = ref<Array<User>>([])
    const seller_id = ref<number>(-1)

    const formatDate = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const getReports = async (range: Array<Date>, seller_id: number | undefined = undefined) => {
        getting.value = true
        const params = new URLSearchParams()
        params.append("from", formatDate(range[0]))
        params.append("to", formatDate(range[1]))
        if (seller_id) {
            seller_id && params.append('seller_id', seller_id.toString())
        }
        
        const res = await Api.get('admin/reports?' + params.toString())
        console.log(res)
        if (res.status == 200) {
            reports.value = res.data.requests
            total.value = res.data.total
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
            for(let key in res.data.errors) {
                ElMessage.error({message: res.data.errors[key]})
            }
        }
        getting.value = false
    }

    const submit = async () => {
        await getReports(range.value, seller_id.value <= 0 ? undefined:seller_id.value)
    }

    onBeforeMount(async () => {
        loading.value = true
        const res = await Api.get('admin/sellers')
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ao buscar os entregadores ' + res.data.message})
            return
        }
        sellers.value = res.data.sellers

        await getReports(range.value)
        loading.value = false
    })

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Relatórios Financeiros" }, _createSlots({
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-position": "top",
          disabled: getting.value,
          class: "p-1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 30 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  sm: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "Datas limite",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          type: "daterange",
                          "unlink-panels": "",
                          "range-separator": "-",
                          "start-placeholder": "Desde",
                          "end-placeholder": "Até",
                          modelValue: range.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((range).value = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  sm: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "Vendido por" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: seller_id.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((seller_id).value = $event)),
                          name: "seller_id",
                          clearable: false
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: -1,
                              label: "Todos vendedores"
                            }, {
                              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createTextVNode(" Todos vendedores ", -1)
                              ]))]),
                              _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sellers.value, (seller) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: seller.id,
                                value: seller.id,
                                label: seller.name
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(seller.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, {
                  sm: 24,
                  md: 8
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "Aplicar filtros" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          plain: "",
                          icon: "Search",
                          loading: getting.value||loading.value,
                          onClick: submit
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode(" Procurar ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_skeleton, {
          rows: 12,
          animated: "",
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createVNode(PersonalTable, {
              loading: loading.value,
              height: 450,
              showRows: 10,
              cols: [
                    {label: 'Cod', prop: 'id'},
                    {label: 'Estado', prop: 'status'},
                ],
              data: reports.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "Cliente",
                  "class-name": "col-auto",
                  "min-width": 150
                }, {
                  default: _withCtx((data) => [
                    _createTextVNode(_toDisplayString(data.row.user.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Entregador",
                  "class-name": "col-auto",
                  "min-width": 150
                }, {
                  default: _withCtx((data) => [
                    _createTextVNode(_toDisplayString(data.row.seller.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Total",
                  "class-name": "col-auto",
                  "min-width": 100
                }, {
                  default: _withCtx((data) => [
                    _createElementVNode("label", _hoisted_2, _toDisplayString(data.row.total) + " MZN ", 1),
                    _createElementVNode("label", _hoisted_3, _toDisplayString(data.row.products.length) + " produtos ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Solicitou em",
                  "class-name": "auto",
                  "min-width": 100
                }, {
                  default: _withCtx((data) => [
                    _createTextVNode(_toDisplayString(new Date(data.row.created_at).toLocaleString()), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "Detalhes" }, {
                  default: _withCtx((data) => [
                    _createElementVNode("span", _hoisted_4, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        tag: "router-link",
                        to: '/requests/' + data.row.id,
                        icon: "View",
                        title: "Ver mais"
                      }, null, 8, ["to"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading", "data"])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 2
    }, [
      (total.value)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _cache[4] || (_cache[4] = _createTextVNode(" Total geral: ", -1)),
              _createElementVNode("label", _hoisted_5, _toDisplayString(total.value) + " MZN ", 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1024)
  ]))
}
}

})